export function createClassNames(names) {
  return names.reduce((result, name) => {
    if (name != null && name !== '') {
      result += ` ${name}`;
    }
    return result;
  }, '');
}

export function arrayToObjectById(items, idSelector = 'id') {
  return items.reduce((r, item) => {
    r[item[idSelector]] = item;
    return r;
  }, {});
}

export function getSizeContain(originalSize, containerSize) {
  const K = originalSize.width / containerSize.width;
  let width = Math.round(originalSize.width / K);
  let height = Math.round(originalSize.height / K);

  if (height > containerSize.height) {
    const K2 = originalSize.height / containerSize.height;
    height = containerSize.height;
    width = Math.round(originalSize.width / K2);
  }

  return { width, height };
}

export function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "WP";
  }

  if (/android/i.test(userAgent)) {
    return "android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return "ios";
  }

  return null;
}

export function isChrome() {
  return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
}

export function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}